/**
 * ════════════════════════════════════════════════════════════════════════════════
 *  관리자 영역 경로 판정
 * ════════════════════════════════════════════════════════════════════════════════
 *  [왜 따로 뺐는가]
 *   '/btcorpad-login' 도 '/btcorpad' 로 시작한다. 그래서 '관리자 경로면 로그인으로
 *   보낸다' 를 단순히 startsWith('/btcorpad') 로 쓰면, 로그인 화면이 스스로를 향해
 *   계속 이동한다. 실수하기 쉬운 판정이라 한 곳에 모아 테스트로 고정한다.
 * ════════════════════════════════════════════════════════════════════════════════
 */

/** 관리자 영역이지만 로그인 없이 들어가야 하는 화면들 */
export const ADMIN_PUBLIC_PATHS = ['/btcorpad-login', '/btcorpad-join', '/btcorpad-pwFind'];

/** 관리자 영역(로그인 화면 포함)인지 — 어느 쪽 갱신수단을 쓸지 고를 때 쓴다 */
export const isAdminPath = (pathName) => String(pathName || '').startsWith('/btcorpad');

/**
 * 이 경로가 '관리자 로그인이 필요한' 경로인지.
 *
 *  @param pathName window.location.pathname
 *  @returns true 면 세션을 확인해야 하고, 없으면 로그인 화면으로 보내야 한다
 */
export const isAdminProtectedPath = (pathName) => {
    const path = String(pathName || '');
    if (!isAdminPath(path)) return false;
    return !ADMIN_PUBLIC_PATHS.some((open) => path.startsWith(open));
};
